/**
 * This helper function takes an API ID (e.g. `1-leads`, `5-users`, etc.), and
 * returns the numeric ID.
 *
 * @param  {string} apiId An API ID
 * @return {number}       The numeric ID
 */
export function getIdFromApiId(apiId: string): number {
    const idAndType = apiId.split('-');
    if (idAndType.length !== 2) {
        throw new Error(`Invalid API ID: ${apiId}`);
    }

    // @ts-ignore
    const id = parseInt(idAndType[0], 10);
    if (isNaN(id)) {
        throw new Error(`Invalid numeric ID in API ID: ${apiId}`);
    }

    return id;
}
